import type { BoxProps } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export interface TableCellProps extends BoxProps {
  children?: string | ReactNode;
  hiddenTitle?: string;
  isHeading?: boolean;
}

export function TableCell({
  isHeading,
  hiddenTitle,
  children,
  ...props
}: TableCellProps) {
  return (
    <Flex as="td" {...props}>
      <Text as="span" size="body3" fontWeight={isHeading ? 'medium' : 'normal'}>
        {children}
      </Text>
    </Flex>
  );
}
